import React, { useEffect, useRef } from "react";
import "./ball-burst.css";

interface BallBurstProps {
    active: boolean;
    onDone: () => void;
    anchorRef: React.RefObject<HTMLElement>;
}

const BALL_COUNT = 10;

const BallBurst: React.FC<BallBurstProps> = ({ active, onDone, anchorRef }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!active || !anchorRef.current || !containerRef.current) return;

        const rect = anchorRef.current.getBoundingClientRect();
        const container = containerRef.current;

        // posiciona o container no botão
        container.style.left = `${rect.left + rect.width / 2}px`;
        container.style.top  = `${rect.top  + rect.height / 2}px`;

        const timer = setTimeout(() => {
            onDone();
        }, 1400);

        return () => clearTimeout(timer);
    }, [active]);

    if (!active) return null;

    return (
        <div ref={containerRef} className="ball-burst-container" aria-hidden>
            {Array.from({ length: BALL_COUNT }).map((_, i) => {
                const angle  = (360 / BALL_COUNT) * i + Math.random() * 20 - 10;
                const dist   = 60 + Math.random() * 80;
                const size   = 16 + Math.random() * 14;
                const delay  = Math.random() * 120;
                const dx     = Math.cos((angle * Math.PI) / 180) * dist;
                const dy     = Math.sin((angle * Math.PI) / 180) * dist - 40; // vai pra cima

                return (
                    <img
                        key={i}
                        src="/img/reacts/ball.png"
                        className="ball-burst-ball"
                        style={{
                            width: size,
                            height: size,
                            animationDelay: `${delay}ms`,
                            "--dx": `${dx}px`,
                            "--dy": `${dy}px`,
                        } as React.CSSProperties}
                        alt=""
                    />
                );
            })}
        </div>
    );
};

export default BallBurst;